import { route } from "@circle-react/lib/routes/define";

export const affiliateRoutes = {
  list: route("/settings/affiliates_directory", {
    title: "Affiliates directory",
    requires: "admin",
    description:
      "Lists all affiliates in the community's affiliate program directory.",
    queryParams: {
      name_or_email: {
        type: "string",
        description:
          "Optional affiliate member name or exact email filter for the affiliates directory table.",
      },
      page: {
        type: "number",
        description: "Optional page number for the affiliates directory table.",
      },
    },
  }),

  commissions: route("/settings/affiliates_commissions", {
    title: "Affiliate commissions",
    requires: "admin",
    description:
      "Review affiliate commissions that are pending, due, processing, or paid.",
    queryParams: {
      active: {
        type: "string",
        description:
          "Optional commissions tab to open: all, pending, due, processing, or paid.",
      },
      page: {
        type: "number",
        description: "Optional page number for the commissions table.",
      },
      query: {
        type: "string",
        description:
          "Optional member name or exact email search query for the commissions table.",
      },
    },
  }),

  settings: route("/settings/affiliates_settings", {
    title: "Affiliate settings",
    requires: "admin",
    description:
      "Set default affiliate commission amounts, pending periods, and payout methods.",
  }),
};
